import { render, staticRenderFns } from "./aggregate.vue?vue&type=template&id=1afa6f69&scoped=true"
import script from "./aggregate.vue?vue&type=script&lang=js"
export * from "./aggregate.vue?vue&type=script&lang=js"
import style0 from "./aggregate.vue?vue&type=style&index=0&id=1afa6f69&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1afa6f69",
  null
  
)

export default component.exports